import axios from "axios";

let numFetchAttempts = 0;
const maxFetchAttempts = 2;

export default {
  async fetchContainer({ commit, dispatch }) {
    try {
      numFetchAttempts += 1;

      const response = await axios.get("/digitaal/digibord/data.json", {
        withCredentials: true,
      });

      if (response.data) {
        commit("setContainer", response.data);
      } else if (numFetchAttempts < maxFetchAttempts) {
        await dispatch("fetchContainer");
      }
    } catch (error) {
      if ([403, 404].includes(error?.response?.status)) {
        window.location.href = "/inloggen-aub";
      }

      if (numFetchAttempts < maxFetchAttempts) {
        await dispatch("fetchContainer");
      }

      // TODO: Else: Display error, allow to trigger retry.
    }
  },
};
